import React, { memo } from 'react'
import { useIntl } from 'react-intl'
import type { CellValue, IdType } from 'react-table'
import type { State } from '@racepointenergy/swc/scs/features/host-states'

import { systemStatesMessages } from '../../messages'
import theme from 'theme_'
import { Body12, BodyPrimary } from 'components/Typography/Labels'
import HomeSystemStateValue from '../HomeSystemStateValue'
import { STATES_HEADERS } from '../../consts'
import {
  MobileTableBlock,
  MobileTableBlockCell,
  MobileTableBlockRow,
} from 'components/Table/MobileBlock/styles'

interface HomeSystemStatesBlockProps {
  values: Record<IdType<State>, CellValue>
}

export function HomeSystemStatesBlock({ values }: HomeSystemStatesBlockProps) {
  const { formatMessage } = useIntl()

  return (
    <MobileTableBlock>
      <MobileTableBlockRow>
        <BodyPrimary bold color={theme.colors.otterWarmBlack}>
          {values[STATES_HEADERS.STATE]}
        </BodyPrimary>
      </MobileTableBlockRow>
      <MobileTableBlockRow>
        <MobileTableBlockCell>
          <Body12 color={theme.colors.darkeyGrey}>
            {formatMessage(systemStatesMessages.stateValueColumn)}
          </Body12>
        </MobileTableBlockCell>
        <MobileTableBlockCell>
          <BodyPrimary color={theme.colors.otterWarmBlack}>
            <HomeSystemStateValue
              value={values[STATES_HEADERS.VALUE]}
              type={values[STATES_HEADERS.TYPE]}
            />
          </BodyPrimary>
        </MobileTableBlockCell>
      </MobileTableBlockRow>
      <MobileTableBlockRow>
        <Body12 color={theme.colors.darkeyGrey}>
          {formatMessage(systemStatesMessages.stateTypeColumn)}
        </Body12>
        <BodyPrimary color={theme.colors.otterWarmBlack}>
          {values[STATES_HEADERS.TYPE]}
        </BodyPrimary>
      </MobileTableBlockRow>
    </MobileTableBlock>
  )
}

export default memo(HomeSystemStatesBlock)
